import { Toast, Modal } from "antd-mobile";
import { ExclamationOutline } from "antd-mobile-icons";
import { Dialog } from "react-vant";
import useGlobal from "../../../hooks/useGlobal";
import useEqiupsComposeModal from "../components/useEqiupsComposeModal";
import useEqiupsModal from "../components/useEqiupsModal";
import useComposingModal from "../components/useComposingModal";
import useEquipModal from "../components/useEquipModal";
import useTansferModal from "../components/useTansferModal";
import useQuilityModal from "../components/useQuilityModal";
import useEquip from "../../../hooks/useEquip";
import { useIntl } from "react-intl";
import moment from 'moment'
import useWallet from "../../../hooks/Wallet/useWallet";
import {shoesHandle} from '../../../api'
import {handlerWalletTxError} from '../../../utils/utils'
import { useNavigate } from "react-router-dom";
import usePersonSign from "../../../hooks/usePersonSign";
export default function useBag() {
  const eqiupsComposeModal = useEqiupsComposeModal();
  const eqiupsModal = useEqiupsModal();
  const composingModal = useComposingModal();
  const equipModal = useEquipModal();
  const tansferModal = useTansferModal();
  const quilityModal = useQuilityModal();
  const intl = useIntl();
  const {myAccount} = useWallet()
  const navigator = useNavigate()
  const { myEquips, userInfo, showLoading, closeLoading } = useGlobal();
  const {
    toBindEquip,
    toUnbindEquip,
    toUnBindQuility,
    composeEquips,
    transfer,
  } = useEquip({ intl });
  const {sendShoesHandle} = usePersonSign()
  const composeFn = (list = []) => {
    let m = eqiupsComposeModal.show({
      list,
      onConfrim: async () => {
        console.log("confrim", list);
        let loading;
        await composeEquips(list, () => {
          m.close();
          loading = composingModal.show({
            onConfrim: () => {
              loading.close();
            },
          });
          return loading;
        });
      },
      onCancel: () => {
        m.close();
      },
      onSelect: (index) => {
        // m.close();
        showEqiupsModal(index, list, m);
      },
    });
  };
  const showEqiupsModal = (index, list, eqiupsComposeModal) => {
    if (!myEquips || !myEquips.length) {
      Toast.show({
        content: intl.formatMessage({
          id: "components.equips_modal.no_equips_error",
          defaultMessage: "無可選擇的裝備",
        }),
      });
      return;
    }
    const m = eqiupsModal.show({
      equips: myEquips.filter(e => !list.find(l => l.id === e.id)),
      defaultId: (list[index] && list[index].id) || "",
      onConfrim: async (item) => {
        console.log("选择的装备", item);
        if (item.equip.level >= 5) {
          Toast.show({
            content: intl.formatMessage({
              id: "components.equips_modal.level_error",
              defaultMessage: "等級已達最高級",
            }),
            icon: <ExclamationOutline />,
          });
          return;
        }

        const isMounted = (userInfo.equips || []).find((e) => e.id === item.id);
        if (isMounted) {
          Toast.show({
            content: intl.formatMessage({
              id: "components.equips_modal.mounted_error",
              defaultMessage: "已穿戴裝備不可合成",
            }),
            icon: <ExclamationOutline />,
          });
          return;
        }
        list[index] = item;
        eqiupsComposeModal.close();
        m.close();
        composeFn(list);
      },
      onCancel: () => {
        m.close();
      },
    });
  };

  const showEqiupModal = (item) => {
    const isMounted =item.is_bind;
    console.log("显示装备详情", item, isMounted);
    const m = equipModal.show({
      isMounted,
      onConfrim: (action) => {
        console.log("action", action);
        if (action.key === "1") {
          if (isMounted) {
            //卸下
            sendShoesHandle('unbinding',{slot:item.slot,id:item.id});
          } else if(item.equip.remain_durability){
            //去装上
            
            navigator('/')
          }
        }
        if (action.key === "2") {
          if (isMounted ) {
            Toast.show({
              content: intl.formatMessage({
                id: "components.equip_modal.tranfer_mounted_error",
                defaultMessage: "請將裝備卸下後再轉讓!",
              }),
              icon: <ExclamationOutline />,
            });
            return;
          }
          const t = tansferModal.show({
            onConfrim: async (address) => {
              await transfer(1, address, item.id);
              t.close();
            },
          });
        }

        m.close();
      },
      equip: item,
    });
  };
  const showQuilityModal = (item) => {
    const mountedEquip = myEquips.find((e) => e.id === item.status);
    console.log("显示属性卡详情", item, mountedEquip);
    const m = quilityModal.show({
      mountedEquip,
      onConfrim: (action) => {
        console.log("action", action);
        if (action.key === "1") {
          //卸下
          const cardIndex = mountedEquip.cards.findIndex(
            (e) => e.id === item.id
          );
          toUnBindQuility(mountedEquip, cardIndex);
        }
        if (action.key === "2") {
          //转让
          if (mountedEquip) {
            Toast.show({
              content: intl.formatMessage({
                id: "components.card_modal.tranfer_mounted_error",
                defaultMessage: "請將屬性卡卸下後再轉讓!",
              }),
              icon: <ExclamationOutline />,
            });
            return;
          }
          const t = tansferModal.show({
            onConfrim: async (address) => {
              await transfer(2, address, item.id);
              t.close();
            },
          });
          m.close();
        } else {
          m.close();
        }
      },
      quility: item,
    });
  };

  const longClickEqiup = (item) => {
    console.log("longClickEqiup", item);
    const isMounted = (userInfo.equips || []).find((e) => e.id === item.id);

    const m = Modal.show({
      title: intl.formatMessage({
        id: "common.tip",
        defaultMessage: "提示",
      }),
      content: (
        <div className="text-center" style={{fontSize: '1.6rem'}}>
          {isMounted
            ? intl.formatMessage({
                id: "common.equip.isUnmountd",
                defaultMessage: "是否卸下？",
              })
            : intl.formatMessage({
                id: "common.equip.isWorn",
                defaultMessage: "是否穿戴？",
              })}
        </div>
      ),
      bodyClassName: "runbit_modal",
      showCloseButton: true,
      actions: [
        {
          key: "1",
          className: "border_btn",
          text: intl.formatMessage({
            id: "common.cancel",
            defaultMessage: "取消",
          }),
        },
        {
          key: "2",
          className: "primary_btn",
          text: intl.formatMessage({
            id: "common.confrim",
            defaultMessage: "確定",
          }),
          primary: true,
        },
      ],
      onAction: (action, index) => {
        
        if (action.key === "2") {
          if (isMounted) {
            toUnbindEquip(item.equip.equipType);
          } else {
            toBindEquip(item);
          }
          
        }
        m.close()
      },
    });
  };

  return {
    composeFn,
    showEqiupModal,
    showQuilityModal,
    longClickEqiup,
  };
}
